<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.stockTransferStatus === 'D'
              ? 'warning'
              : row.stockTransferStatus === 'N'
              ? 'primary'
              : 'success'
          "
        >
          {{ row.v_stockTransferStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                $emit('openEditDialog', {
                  type: 'detail',
                  code: row.mrpStockTransferCode,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="allow('M') && row.stockTransferStatus === 'N'"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                $emit('openEditDialog', {
                  type: 'edit',
                  code: row.mrpStockTransferCode,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-if="allow('D') && row.stockTransferStatus === 'N'"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_submit_review') || '提交审核'"
            placement="top"
            v-if="allow('C') && row.stockTransferStatus === 'N'"
          >
            <i class="el-icon-position tool-btn" @click="submit(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:createInfo="{ row }">
        <span> {{ row.createByName }} </span>
        <br />
        <span> {{ row.createDate }} </span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span> {{ row.modifyByName }} </span>
        <br />
        <span> {{ row.modifyDate }} </span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, defaul: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    del({ mrpStockTransferCode }) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .mrpStockTransferDelApi({ mrpStockTransferCode })
          .then(() => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
    submit(row) {
      this.$confirm(
        this.$l('INDEX.tips_question_submitAudit') || '是否要提交审核？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          this.loadingOpen()
          this.$api
            .mrpStockTransferSubmitApi({
              mrpStockTransferCode: row.mrpStockTransferCode,
            })
            .then(() => {
              this.loadingClose()
              this.$message({
                showClose: true,
                message:
                  this.$l('INDEX.tips_Submitted_successfully') || '提交成功！',
                type: 'success',
              })
              this.$emit('reload')
            })
            .catch(() => {
              this.loadingClose()
            })
        })
        .catch(() => {
          this.loadingClose()
        })
    },
  },
}
</script>
